<template>
  <Panel>
    <template slot="panel">
      <Breadcrumb :routes="routes"></Breadcrumb>
      <ContactUs ref="ContactUs"></ContactUs>
      <Space></Space>
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import Breadcrumb from '@/components/breadcrumb'
import ContactUs from '@/components/contact-us'
import Space from '@/components/space'
export default {
  components: {
    Panel,
    Breadcrumb,
    ContactUs,
    Space
  },

  data () {
    return {
      routes: [{
        name: this.$root.language.jwisoftware,
        path: '/'
      },
      {
        name: this.$root.language.company,
        path: ''
      },
      {
        name: this.$root.language.contactUs,
        path: '/company/contact'
      }
      ],
      backgroundImg: {
        backgroundImage: `url(${require('@/assets/img/line.png')})`,
        backgroundRepeat: 'repeat-x',
        backgroundPosition: 'left center'
      },
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>

<style scoped>

</style>
